import { Map, List } from 'immutable';
import { actions } from 'actions/admin/withdrawals.js';

const initialState = new Map({
  isFetching: false,
  errors: new List([]),
  data: new List(),
});

export default function adminWithdrawalsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ADMIN_WITHDRAWALS_FETCH:
      return state.merge({ isFetching: true });
    case actions.ADMIN_WITHDRAWALS_FETCH_SUCCESS: {
      return state.merge({ isFetching: false }).mergeIn(['data'], action.body.results.withdrawals);
    }
    case actions.ADMIN_WITHDRAWALS_FETCH_FAILURE:
      return state.merge({ isFetching: true });
    default:
      return state;
  }
}
